var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "buyProduct-content" },
    [
      _c("div", { staticClass: "buyProduct" }, [
        _c("div", { staticClass: "basic-information-title" }, [
          _vm._v("拥有产品")
        ]),
        _vm._v(" "),
        _c("div", [
          _vm.showCC == true && _vm.hasPRCreated
            ? _c("img", {
                staticClass: "newlyAddImg",
                staticStyle: { "margin-right": "0.2rem" },
                attrs: {
                  src: require("@/assets/img/scan_code.png"),
                  alt: "",
                  srcset: ""
                },
                on: {
                  click: function($event) {
                    return _vm.scanQR()
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showCC == true && _vm.hasPRCreated
            ? _c("img", {
                staticClass: "newlyAddImg",
                attrs: {
                  src: require("@/assets/img/newlyAdd.png"),
                  alt: "",
                  srcset: ""
                },
                on: {
                  click: function($event) {
                    return _vm.redact(1)
                  }
                }
              })
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "van-tabs",
        {
          attrs: { sticky: "", swipeable: "", "title-active-color": "red" },
          model: {
            value: _vm.tabActive,
            callback: function($$v) {
              _vm.tabActive = $$v
            },
            expression: "tabActive"
          }
        },
        _vm._l(_vm.tab, function(tabItem, index) {
          return _c(
            "van-tab",
            { key: tabItem.index, attrs: { title: tabItem.name } },
            [
              _vm.list.length > 0
                ? _c(
                    "div",
                    { staticClass: "product-list" },
                    _vm._l(_vm.list, function(item, index) {
                      return item.products1stType == tabItem.key ||
                        (tabItem.key == "运动光学" &&
                          item.products1stType == "配件")
                        ? _c("div", { key: index }, [
                            _c(
                              "div",
                              { staticClass: "flex product-list-header" },
                              [
                                _c("div", { staticClass: "flex center" }, [
                                  _c("img", {
                                    staticClass: "camera",
                                    attrs: {
                                      src: require("@/assets/img/camera.png"),
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "product-name" }, [
                                    _vm._v(
                                      "产品大类-" +
                                        _vm._s(item.products1stType || "")
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm.showCC == true && _vm.hasPRModified
                                  ? _c("img", {
                                      staticClass: "redactImg",
                                      attrs: {
                                        src: require("@/assets/img/redact.png"),
                                        alt: "",
                                        srcset: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.redact(
                                            2,
                                            item.purchaseRecordId
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "product-list-content" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "basic-information-flex",
                                  class:
                                    item.edit == true ? "active" : "activeno"
                                },
                                [
                                  _c("div", { staticClass: "list-status" }, [
                                    item.activatedState != 1
                                      ? _c("p", [_vm._v("未激活")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.activatedState == 1
                                      ? _c("p", [_vm._v("已激活")])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    { staticClass: "basic-information-lists" },
                                    [
                                      _c("li", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-item"
                                          },
                                          [_vm._v("购买日期")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-text"
                                          },
                                          [_vm._v(_vm._s(item.buyDate))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-item"
                                          },
                                          [_vm._v("门店")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-text"
                                          },
                                          [_vm._v(_vm._s(item.deptName || ""))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-item"
                                          },
                                          [_vm._v("中文名称")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-text"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.productNameCH || "")
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-item"
                                          },
                                          [_vm._v("销售金额")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-text"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$numeral(item.amountAftTax)
                                                  .format("0,0.00")
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-item"
                                          },
                                          [_vm._v("产品编号")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-text"
                                          },
                                          [_vm._v(_vm._s(item.code))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-item"
                                          },
                                          [_vm._v("产品大类")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-text"
                                          },
                                          [_vm._v(_vm._s(item.products1stType))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-item"
                                          },
                                          [_vm._v("产品分类")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-text"
                                          },
                                          [_vm._v(_vm._s(item.products2ndType))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-item"
                                          },
                                          [_vm._v("产品英文")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-text"
                                          },
                                          [_vm._v(_vm._s(item.productNameEN))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-item"
                                          },
                                          [_vm._v("序列号")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-text"
                                          },
                                          [_vm._v(_vm._s(item.serial))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-item"
                                          },
                                          [_vm._v("未激活原因")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-text"
                                          },
                                          [_vm._v(_vm._s(item.reason))]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-item"
                                          },
                                          [_vm._v("保修期")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-text"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.defectsLiabilityPeriod ||
                                                  ""
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-item"
                                          },
                                          [_vm._v("延保服务期")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-text"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.extensionServicePeriod
                                              )
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-item"
                                          },
                                          [_vm._v("保修到期日")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "basic-information-lists-text"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.warrantyExpirationDate
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "flex packUp center",
                                on: {
                                  click: function($event) {
                                    return _vm.packUp(index)
                                  }
                                }
                              },
                              [
                                item.edit == true
                                  ? _c("img", {
                                      staticClass: "arrow",
                                      attrs: {
                                        src: require("@/assets/img/upArrow1.png"),
                                        alt: "",
                                        srcset: ""
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                item.edit == false
                                  ? _c("img", {
                                      staticClass: "arrow",
                                      attrs: {
                                        src: require("@/assets/img/dowmArrow.png"),
                                        alt: "",
                                        srcset: ""
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      item.edit == true
                                        ? "收起详情"
                                        : "展开详情"
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    }),
                    0
                  )
                : _vm._e()
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "product-model" },
        [
          _c(
            "van-popup",
            {
              attrs: { overlay: true, "close-on-click-overlay": false },
              model: {
                value: _vm.productShow,
                callback: function($$v) {
                  _vm.productShow = $$v
                },
                expression: "productShow"
              }
            },
            [
              _c("div", { staticClass: "model-height" }, [
                _c("div", { staticClass: "product-title" }, [
                  _vm._v(_vm._s(_vm.nameTitle) + "购买产品")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "basic-models-list" }, [
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("购买日期")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "selectUp",
                        on: {
                          click: function($event) {
                            return _vm.timeSelections()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.pullList[12]["name"] || "请选择") +
                            "\n              "
                        ),
                        _c("img", {
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("产品货号")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pullList[0]["name"],
                          expression: "pullList[0]['name']"
                        }
                      ],
                      attrs: {
                        type: "text",
                        oninput: "if(value.length>50)value=value.slice(0,50)",
                        disabled: _vm.pullList[0]["editTallage"] != null,
                        placeholder: "请输入产品货号"
                      },
                      domProps: { value: _vm.pullList[0]["name"] },
                      on: {
                        blur: function($event) {
                          _vm.pullList[0]["name"] != ""
                            ? _vm.productCode(_vm.pullList[0]["name"])
                            : ""
                        },
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.productCode(_vm.pullList[0]["name"])
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.pullList[0], "name", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("序列号")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pullList[1]["name"],
                          expression: "pullList[1]['name']"
                        }
                      ],
                      attrs: {
                        type: "text",
                        placeholder: _vm.editS == true ? "请输入序号" : "",
                        disabled: _vm.pullList[1]["editTallage"] != null,
                        oninput: "if(value.length>50)value=value.slice(0,50)"
                      },
                      domProps: { value: _vm.pullList[1]["name"] },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.serialCode(_vm.pullList[1]["name"])
                        },
                        blur: function($event) {
                          return _vm.serialCode(_vm.pullList[1]["name"])
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.pullList[1], "name", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("产品大类")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "selectUp",
                        on: {
                          click: function($event) {
                            _vm.pullList[2]["editTallage"] != null
                              ? ""
                              : _vm.downSelections(2)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.pullList[2]["name"] || "请选择") +
                            "\n              "
                        ),
                        _c("img", {
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("产品分类")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "selectUp",
                        on: {
                          click: function($event) {
                            _vm.pullList[3]["editTallage"] != null
                              ? ""
                              : _vm.downSelections(3)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.pullList[3]["name"] || "请选择") +
                            "\n              "
                        ),
                        _c("img", {
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("产品中文名")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pullList[4]["name"],
                          expression: "pullList[4]['name']"
                        }
                      ],
                      attrs: {
                        type: "text",
                        oninput: "if(value.length>50)value=value.slice(0,50)",
                        disabled: _vm.pullList[4]["editTallage"] != null,
                        placeholder: "请输入产品中文名"
                      },
                      domProps: { value: _vm.pullList[4]["name"] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.pullList[4], "name", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("产品英文名")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pullList[5]["name"],
                          expression: "pullList[5]['name']"
                        }
                      ],
                      attrs: {
                        type: "text",
                        oninput: "if(value.length>50)value=value.slice(0,50)",
                        disabled: _vm.pullList[5]["editTallage"] != null,
                        placeholder: "请输入产品英文名"
                      },
                      domProps: { value: _vm.pullList[5]["name"] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.pullList[5], "name", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("建议零售价")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pullList[13]["name"],
                          expression: "pullList[13]['name']"
                        }
                      ],
                      attrs: { type: "number", disabled: "disabled" },
                      domProps: { value: _vm.pullList[13]["name"] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.pullList[13],
                            "name",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("销售金额")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pullList[6]["name"],
                          expression: "pullList[6]['name']"
                        }
                      ],
                      attrs: {
                        type: "number",
                        oninput: "if(value.length>50)value=value.slice(0,50)",
                        placeholder: "请输入销售金额"
                      },
                      domProps: { value: _vm.pullList[6]["name"] },
                      on: {
                        blur: _vm.ratesCount,
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.pullList[6], "name", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: false,
                          expression: "false"
                        }
                      ],
                      staticClass: "basic-models-list-item"
                    },
                    [
                      _c("div", { staticClass: "models-list-item-title" }, [
                        _vm._v("未税金额")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.pullList[7]["name"],
                            expression: "pullList[7]['name']"
                          }
                        ],
                        attrs: {
                          type: "number",
                          disabled: _vm.editTallage,
                          oninput: "if(value.length>50)value=value.slice(0,50)",
                          placeholder: "请输入未税金额"
                        },
                        domProps: { value: _vm.pullList[7]["name"] },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.pullList[7],
                              "name",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "basic-models-list-item",
                      staticStyle: { height: "1.5rem" }
                    },
                    [
                      _c("div", { staticClass: "models-list-item-title" }, [
                        _vm._v("上传购买凭证")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "van-uploader__preview" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "van-image van-uploader__preview-image",
                            on: {
                              click: function($event) {
                                return _vm.selectImage()
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "van-image__img",
                              staticStyle: { "object-fit": "cover" },
                              attrs: { src: _vm.uploadCertificate }
                            })
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("优惠劵")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "selectUp",
                        on: {
                          click: function($event) {
                            return _vm.downSelections(8)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.pullList[8]["name"] || "请选择") +
                            "\n              "
                        ),
                        _c("img", {
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("未激活原因")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pullList[14]["name"],
                          expression: "pullList[14]['name']"
                        }
                      ],
                      attrs: {
                        type: "text",
                        disabled: "disabled",
                        placeholder: "暂无"
                      },
                      domProps: { value: _vm.pullList[14]["name"] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.pullList[14],
                            "name",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("劵号")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.pullList[9]["name"],
                          expression: "pullList[9]['name']"
                        }
                      ],
                      attrs: {
                        type: "text",
                        maxlength: "50",
                        placeholder: "请输入劵号"
                      },
                      domProps: { value: _vm.pullList[9]["name"] },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.pullList[9], "name", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("购买门店")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "selectUp",
                        on: {
                          click: function($event) {
                            return _vm.downSelections(10)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.pullList[10]["name"] || "请选择") +
                            "\n              "
                        ),
                        _c("img", {
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "basic-models-list-item" }, [
                    _c("div", { staticClass: "models-list-item-title" }, [
                      _vm._v("销售顾问")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "selectUp",
                        on: {
                          click: function($event) {
                            _vm.pullList[10]["val"]
                              ? _vm.downSelections(11)
                              : ""
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.pullList[11]["name"] || "请选择") +
                            "\n              "
                        ),
                        _c("img", {
                          staticClass: "uparrow",
                          attrs: {
                            src: require("@/assets/img/uparrow.png"),
                            alt: "",
                            srcset: ""
                          }
                        })
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "confirm-cancel" }, [
                _c(
                  "div",
                  { staticClass: "button-flex-color flex-border-button" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "button-flex-item",
                        on: { click: _vm.cancelProduct }
                      },
                      [_vm._v("取消")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "button-flex-color" }, [
                  _c(
                    "div",
                    {
                      staticClass: "button-flex-item button-active",
                      on: { click: _vm.confirmProduct }
                    },
                    [_vm._v("确定")]
                  )
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom", overlay: true },
          model: {
            value: _vm.showDownSelection,
            callback: function($$v) {
              _vm.showDownSelection = $$v
            },
            expression: "showDownSelection"
          }
        },
        [
          _c("van-picker", {
            staticClass: "van-picker-li",
            attrs: {
              "show-toolbar": "",
              title: "",
              columns: _vm.downSelection,
              "value-key": "name" || "deptName"
            },
            on: { cancel: _vm.onCancelCode, confirm: _vm.onConfirmCode }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticStyle: { width: "100%" },
          attrs: { position: "bottom", overlay: true },
          model: {
            value: _vm.timeShow,
            callback: function($$v) {
              _vm.timeShow = $$v
            },
            expression: "timeShow"
          }
        },
        [
          _c("van-datetime-picker", {
            attrs: {
              type: "date",
              "max-date": _vm.maxDate,
              "min-date": _vm.minDate
            },
            on: { confirm: _vm.timeConfirm, cancel: _vm.timeCancel },
            model: {
              value: _vm.currentDate,
              callback: function($$v) {
                _vm.currentDate = $$v
              },
              expression: "currentDate"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "product-model-min" },
        [
          _c(
            "van-popup",
            {
              model: {
                value: _vm.submitShow,
                callback: function($$v) {
                  _vm.submitShow = $$v
                },
                expression: "submitShow"
              }
            },
            [
              _c("div", { staticClass: "model-height" }, [
                _c("div", { staticClass: "product-title" }, [
                  _vm._v("激活保卡信息上传成功")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "confirm-cancel" }, [
                _c("div", { staticClass: "button-flex-color" }, [
                  _c(
                    "div",
                    {
                      staticClass: "button-flex-item button-active",
                      on: { click: _vm.submitShowf }
                    },
                    [_vm._v("确定")]
                  )
                ])
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f9fb028", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f9fb028","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/childCompoents/haveProduct.vue
// module id = null
// module chunks = 